module.exports = __webpack_public_path__ + "caret.svg?b53988d393394ce6bb6b328bdb531f37";